module.exports = __webpack_public_path__ + "img/badge-platinum.3e7c2df9.svg";